module.exports = "/images/blister-0.png";